import classnames from 'classnames/bind'
import * as styles from './index.module.css'

const cx = classnames.bind(styles)

export default function DefautButton({ title, isPrimary, isLoading, isBack, disabled, onClick, tabIndex, isSmall, className, children, fullscreen}) {
  return (
        <button 
        key={title}
        type="button" 
        tabIndex={tabIndex !== undefined ? tabIndex : 0}
        onClick={onClick}
        className={cx(styles.button, { isPrimary, isBack, isLoading, isSmall })}
        disabled={disabled}
        dangerouslySetInnerHTML={{ __html: title }}
        />
  )
}
